import makeStyles from '@mui/styles/makeStyles';

import { teal900 } from '@/theme/colors';

export const useStyles = makeStyles({
  paper: {
    margin: 'auto',
    padding: '0 !important',
    '& form': {
      display: 'flex',
      flexDirection: 'column',
    },
  },

  // Content
  content: {
    padding: '4px 0 16px',
    backgroundColor: 'var(--surfaceCard)',
  },

  // Payment section
  paymentSection: {
    marginTop: 12,
    padding: '0 24px', // Match SchedulingForm alignment
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: 'var(--onSurface)',
    margin: '0 0 12px 0',
  },

  // Payment method display
  paymentMethod: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    backgroundColor: 'var(--surfaceSecondary)',
    border: '1px solid var(--surfaceBorder)',
    borderRadius: 8,
  },
  paymentMethodInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  cardBrand: {
    fontSize: 12,
    fontWeight: 600,
    color: 'var(--onSurfaceSecondary)',
    backgroundColor: 'var(--surfaceMuted)',
    padding: '2px 6px',
    borderRadius: 4,
  },
  cardNumber: {
    fontSize: 14,
    color: 'var(--onSurface)',
    fontFamily: 'monospace',
  },
  cardExpiry: {
    fontSize: 12,
    color: 'var(--onSurfaceMuted)',
  },
  changePaymentLink: {
    fontSize: 14,
    color: 'var(--brandPrimary)',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  paymentMethodEmpty: {
    padding: '12px 16px',
    backgroundColor: '#FEF2F2',
    border: '1px solid #FECACA',
    borderRadius: 8,
  },
  paymentMethodEmptyText: {
    fontSize: 14,
    color: '#DC2626',
    margin: 0,
  },

  // Booking fee disclosure failure (ER-originated SMB): block submit + offer retry
  bookingFeeNotice: {
    marginTop: 12,
    padding: '0 24px', // Match SchedulingForm/paymentSection alignment
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 8,
  },
  bookingFeeNoticeText: {
    fontSize: 14,
    color: 'var(--red500)',
    margin: 0,
  },

  // Footer
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    borderTop: '1px solid var(--surfaceBorder)',
    backgroundColor: 'var(--surfaceSecondary)',
  },
  cancelButton: {
    fontSize: 14,
    fontWeight: 500,
    color: 'var(--brandPrimary)',
    background: 'none',
    border: 'none',
    padding: '8px 16px',
    cursor: 'pointer',
    textTransform: 'uppercase',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  submitButton: {
    fontSize: 14,
    fontWeight: 500,
    color: 'white',
    backgroundColor: teal900,
    border: 'none',
    borderRadius: 4,
    padding: '10px 24px',
    cursor: 'pointer',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: '#004544',
    },
    '&:disabled': {
      backgroundColor: 'var(--surfaceMuted)',
      color: 'var(--onSurfaceMuted)',
      cursor: 'not-allowed',
    },
  },
});
